<div class="border-top pt-3 mb-3">
  <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
    <h2 class="fs-6 fw-bold mb-0"><i class="bi bi-crosshair me-2 text-primary"></i>Goals</h2>
    @if (loaded) {
      <div class="d-flex align-items-center gap-2">
        <span class="small text-muted text-nowrap">Copy goals from</span>
        <app-dropdown-select placeholder="Select an offer" [(ngModel)]="sourceOfferId"
                             (ngModelChange)="copyFromOffer($event)" [ngModelOptions]="{standalone: true}">
          @for (offer of sourceOffers; track offer.id) {
            <app-dropdown-select-option [value]="offer.id">{{ offer.name }}</app-dropdown-select-option>
          }
        </app-dropdown-select>
      </div>
    }
  </div>
  <div>
    @if (isMissing()) {
      <div class="alert py-2 small" [class.alert-danger]="submitted" [class.alert-warning]="!submitted">
        <i class="bi bi-exclamation-triangle me-1"></i>
        An offer open to affiliates needs at least one goal: without it, conversions are paid but stay private and never reach the invoice.
      </div>
    }
    @if (loaded) {
      <div class="table-responsive">
        <table class="table align-middle mb-0">
          <thead>
            <tr>
              <th>Status</th>
              <th>Name</th>
              <th>Min Age</th>
              <th>Payout Amount</th>
              <th>Payout Percent</th>
              <th>Private</th>
              <th>Multiple</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (goal of availableGoals; track goal.id) {
              @let goalForm = findGoalForm(goal);
              <tr>
                <td>
                  <app-input-switch [ngModel]="!!goalForm" [ngModelOptions]="{standalone: true}"
                                    (change)="toggleGoal(goal, $event)"></app-input-switch>
                </td>
                <td class="fw-bold">{{ goal.name }}</td>
                @if (goalForm) {
                  <ng-container [formGroup]="goalForm">
                    <td><input type="number" min="1" step="1" class="form-control form-control-sm" formControlName="minAge"></td>
                    <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" formControlName="payoutAmount"></td>
                    <td>
                      <div class="input-group input-group-sm">
                        <input type="number" min="0" max="100" step="0.01" class="form-control" formControlName="payoutPercent">
                        <span class="input-group-text">%</span>
                      </div>
                    </td>
                    <td><app-input-switch formControlName="private"></app-input-switch></td>
                    <td><app-input-switch formControlName="multiple"></app-input-switch></td>
                    <td>
                      @if (getAvailableGoalTypes(goal).length) {
                        <div class="input-group input-group-sm flex-nowrap">
                          <select class="form-select" [(ngModel)]="selectedGoalTypes[goal.id!]"
                                  [ngModelOptions]="{standalone: true}">
                            <option [ngValue]="null" disabled selected>Add a type</option>
                            @for (goalType of getAvailableGoalTypes(goal); track goalType.id) {
                              <option [ngValue]="goalType">{{ goalType.name }}</option>
                            }
                          </select>
                          <button type="button" class="btn btn-primary" (click)="addGoalType(goal)"
                                  [disabled]="!selectedGoalTypes[goal.id!]"><i class="bi bi-plus-lg"></i></button>
                        </div>
                      }
                    </td>
                  </ng-container>
                } @else {
                  <td colspan="6"></td>
                }
              </tr>
              @if (goalForm) {
                @for (typeForm of goalForm.controls.types.controls; track typeForm; let i = $index) {
                  <tr [formGroup]="typeForm" class="small">
                    <td></td>
                    <td class="ps-4 text-muted"><i class="bi bi-arrow-return-right me-1"></i>{{ typeForm.value.name }}</td>
                    <td><input type="number" min="1" step="1" class="form-control form-control-sm" formControlName="minAge"></td>
                    <td><input type="number" min="0" step="0.01" class="form-control form-control-sm" formControlName="payoutAmount"></td>
                    <td>
                      <div class="input-group input-group-sm">
                        <input type="number" min="0" max="100" step="0.01" class="form-control" formControlName="payoutPercent">
                        <span class="input-group-text">%</span>
                      </div>
                    </td>
                    <td colspan="2"></td>
                    <td class="text-end">
                      <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeGoalType(goalForm, i)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                }
              }
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
